{
  "id": "google.com",
  "version": 0,
  "name": "Google",
  "author": "SR",
  "date": "2023-01-01",
  "url": "https://www.google.com",
  "strings": {
    "en": {
      "name": "Google",
      "help": [
        "https://takeout.google.com/settings/takeout",
        "(Log in with your Google Account)",
        "Your export could be too big for this app. For this reason deselect Drive, Gmail, Google Photos and Youtube",
        "At the bottom click 'Next Step' and then 'Create archive'",
        "Wait for the Email and follow the instructions (takes 1-20 minutes usually)"
      ]
    },
    "de": {
      "name": "Google",
      "help": [
        "https://takeout.google.com/settings/takeout",
        "(Melde Dich an)",
        "Dein Export könnte zu groß werden. Deshalb deselektiere Drive, Gmail, Google Fotos und Youtube.",
        "Klicke unten auf der Seite 'Nächster Schritt' und klicke 'Archiv erstellen'",
        "Du erhälst eine Email zum Herunterladen in etwa 1-20 Minuten."
      ]
    }
  },
  "instructions": [
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }, { "type": "empty" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "locations": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "latitudeE7": [
                                  {
                                    "type": "number",
                                    "supposedUsage": { "format": "lat" }
                                  }
                                ],
                                "longitudeE7": [
                                  {
                                    "type": "number",
                                    "supposedUsage": { "format": "long" }
                                  }
                                ],
                                "accuracy": [{ "type": "number" }],
                                "activity": [
                                  {
                                    "type": "array",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "activity": [
                                            {
                                              "type": "array",
                                              "anyOf": [
                                                {
                                                  "type": "object",
                                                  "properties": {
                                                    "type": [{ "type": "string" }],
                                                    "confidence": [{ "type": "number" }]
                                                  }
                                                }
                                              ]
                                            }
                                          ],
                                          "timestamp": [
                                            {
                                              "type": "string",
                                              "supposedUsage": {
                                                "format": "time",
                                                "argument": { "iso": true }
                                              }
                                            }
                                          ]
                                        }
                                      }
                                    ]
                                  },
                                  { "type": "empty" }
                                ],
                                "source": [{ "type": "string" }, { "type": "empty" }],
                                "deviceTag": [{ "type": "number" }],
                                "timestamp": [
                                  {
                                    "type": "string",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "iso": true }
                                    }
                                  }
                                ],
                                "deviceDesignation": [{ "type": "string" }, { "type": "empty" }],
                                "altitude": [{ "type": "number" }, { "type": "empty" }],
                                "verticalAccuracy": [{ "type": "number" }, { "type": "empty" }],
                                "platformType": [{ "type": "string" }],
                                "osLevel": [{ "type": "number" }, { "type": "empty" }],
                                "serverTimestamp": [
                                  {
                                    "type": "string",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "iso": true }
                                    }
                                  }
                                ],
                                "deviceTimestamp": [
                                  {
                                    "type": "string",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "iso": true }
                                    }
                                  }
                                ],
                                "batteryCharging": [{ "type": "boolean" }, { "type": "empty" }],
                                "formFactor": [{ "type": "string" }],
                                "locationMetadata": [
                                  {
                                    "type": "array",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "wifiScan": [
                                            {
                                              "type": "object",
                                              "properties": {
                                                "accessPoints": [
                                                  {
                                                    "type": "array",
                                                    "anyOf": [
                                                      {
                                                        "type": "object",
                                                        "properties": {
                                                          "mac": [
                                                            {
                                                              "type": "string",
                                                              "supposedUsage": {
                                                                "format": "time",
                                                                "argument": {
                                                                  "factor": 0.001
                                                                }
                                                              }
                                                            }
                                                          ],
                                                          "strength": [{ "type": "number" }],
                                                          "frequencyMhz": [{ "type": "number" }],
                                                          "rttMeasurementAttempts": [
                                                            {
                                                              "type": "number"
                                                            },
                                                            { "type": "empty" }
                                                          ],
                                                          "successfulRttMeasurements": [
                                                            {
                                                              "type": "number"
                                                            },
                                                            { "type": "empty" }
                                                          ],
                                                          "rttEstimatedDistanceMm": [
                                                            {
                                                              "type": "number"
                                                            },
                                                            { "type": "empty" }
                                                          ],
                                                          "rttDistanceStdDevMm": [
                                                            {
                                                              "type": "number"
                                                            },
                                                            { "type": "empty" }
                                                          ],
                                                          "rttChannelBandwidth": [
                                                            {
                                                              "type": "number"
                                                            },
                                                            { "type": "empty" }
                                                          ]
                                                        }
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            }
                                          ],
                                          "timestamp": [
                                            {
                                              "type": "string",
                                              "supposedUsage": {
                                                "format": "time",
                                                "argument": { "iso": true }
                                              }
                                            }
                                          ],
                                          "wifiConnectivityStatus": [
                                            {
                                              "type": "object",
                                              "properties": {
                                                "wifiConnectionStatus": [{ "type": "string" }],
                                                "mac": [
                                                  {
                                                    "type": "string",
                                                    "supposedUsage": {
                                                      "format": "time",
                                                      "argument": {
                                                        "factor": 0.001
                                                      }
                                                    }
                                                  }
                                                ]
                                              }
                                            },
                                            { "type": "empty" }
                                          ]
                                        }
                                      }
                                    ]
                                  },
                                  { "type": "empty" }
                                ],
                                "inferredLocation": [
                                  {
                                    "type": "array",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "timestamp": [
                                            {
                                              "type": "string",
                                              "supposedUsage": {
                                                "format": "time",
                                                "argument": { "iso": true }
                                              }
                                            }
                                          ],
                                          "latitudeE7": [
                                            {
                                              "type": "number",
                                              "supposedUsage": {
                                                "format": "lat"
                                              }
                                            }
                                          ],
                                          "longitudeE7": [
                                            {
                                              "type": "number",
                                              "supposedUsage": {
                                                "format": "long"
                                              }
                                            }
                                          ],
                                          "accuracy": [{ "type": "number" }]
                                        }
                                      }
                                    ]
                                  },
                                  { "type": "empty" }
                                ],
                                "velocity": [{ "type": "number" }, { "type": "empty" }],
                                "heading": [{ "type": "number" }, { "type": "empty" }],
                                "activeWifiScan": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "accessPoints": [
                                        {
                                          "type": "array",
                                          "anyOf": [
                                            {
                                              "type": "object",
                                              "properties": {
                                                "mac": [
                                                  {
                                                    "type": "string",
                                                    "supposedUsage": {
                                                      "format": "time",
                                                      "argument": {
                                                        "factor": 0.001
                                                      }
                                                    }
                                                  }
                                                ],
                                                "strength": [{ "type": "number" }],
                                                "frequencyMhz": [{ "type": "number" }],
                                                "isConnected": [{ "type": "boolean" }, { "type": "empty" }]
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  },
                                  { "type": "empty" }
                                ],
                                "placeId": [{ "type": "string" }, { "type": "empty" }]
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [],
      "hidden": false
    }
  ],
  "fileStructure": ["takeout/"],
  "optionalFileStructure": []
}
